import '~base';
import processInclude from 'base/util';
import $ from 'jquery';

// eslint-disable-next-line no-undef
$(document).ready(() => {
  processInclude(require('./constructor/search'));
});
